import '../../Styles/CustomTooltip.css'

const CustomTooltip = ({ active, payload, label, coordinate, viewBox }) => {
  if (active && payload && payload.length) {
    const options = {
      style: 'currency',
      currency: 'DKK',
    };
    
  
      return (
        <div className="custom-tooltip">
          <p className="label" style={{fontWeight:"bold"}}>{`Måned: ${label}`}</p>
          <p className="desc" style={{fontWeight:"bold"}}>{`Omsætning Nuværende År: ${Intl.NumberFormat('dk-DK', options).format(payload?.[0]?.value)}`}</p>
          <p className="desc" style={{fontWeight:"bold"}}>{`Omsætning Sidst år: ${Intl.NumberFormat('dk-DK', options).format(payload?.[1]?.value)}`}</p>
          <p className="desc" style={{fontWeight:"bold"}}>{`Budget Nuværende År: ${Intl.NumberFormat('dk-DK', options).format(payload?.[2]?.value)}`}</p>
          <p className="desc" style={{fontWeight:"bold"}}>{`Resultat Nuværende År: ${Intl.NumberFormat('dk-DK', options).format(payload?.[3]?.value)}`}</p>
          <p className="desc" style={{fontWeight:"bold"}}>{`Resultat Sidste år: ${Intl.NumberFormat('dk-DK', options).format(payload?.[4]?.value)}`}</p>
        </div>
      );
    }
  
    return null;
  };
  export default CustomTooltip